export const AUDIO_INPUT = 'audioinput';
export const AUDIO_OUTPUT = 'audiooutput';
export const VIDEO_INPUT = 'videoinput';